<template>
  <exo-help-dialog title="Optimisation type">
    <table>
      <tbody>
        <tr>
          <td>ΔV &nbsp;</td>
          <td>
            Minimise the ΔV and thus the propellant needed to fulfill the
            mission.
          </td>
        </tr>
        <tr>
          <td>ΔRAAN+ / ΔRAAN- &nbsp;</td>
          <td>
            Maximise the relative* RAAN phasing (positive or negative change of
            RAAN).
          </td>
        </tr>
        <tr>
          <td>ΔT &nbsp;</td>
          <td>Minimise the duration of the mission.</td>
        </tr>
      </tbody>
    </table>
    <br />
    *Here ΔRAAN must be understood as a relative RAAN phasing with respect to
    the chosen RAAN phasing reference. See mission description for more details.
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipOptimizationType'
}
</script>
